
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/feedback/parental-controls",
      function () {
        return require("private-next-pages/[locale]/feedback/parental-controls/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/feedback/parental-controls"])
      });
    }
  